import React from 'react';
import { Typography, Tooltip, Chip } from '@material-ui/core';
import { useStyles } from './DiagnosticSummary.style';

const OtherLesions = ({ lesions = [], onMouseEnter, onMouseLeave, onClick }) => {
  const classes = useStyles();

  return (
    <div
      style={{
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        marginRight: '12px',
      }}>
      {lesions.map((lesion) => (
        <Tooltip
          key={lesion.key}
          arrow
          placement='top-end'
          title={<Typography className={classes.tooltip_text}>{lesion.tooltip}</Typography>}>
          <Chip
            size='small'
            className={classes.other_birads_chip}
            label={lesion.label}
            variant='outlined'
            style={{
              backgroundColor: lesion.exist
                ? lesion.isShown
                  ? `${lesion.color}70`
                  : `${lesion.color}40`
                : 'transparent',
              border: lesion.exist ? `1px solid ${lesion.color}50` : '1px solid gray',
              color: lesion.exist ? (lesion.isShown ? 'white' : lesion.color) : 'gray',
              cursor: lesion.exist ? 'pointer' : 'default',
              fontWeight: lesion.isShown ? 'bold' : 'normal',
            }}
            onMouseEnter={() =>
              onMouseEnter(lesion.module, lesion.exist, lesion.isShown, lesion.overlaysToShow)
            }
            onMouseLeave={() => onMouseLeave(lesion.module, lesion.overlaysToShow)}
            onClick={() => onClick(lesion.module, lesion.overlaysToShow, lesion.isShown, lesion.exist)}
          />
        </Tooltip>
      ))}
    </div>
  );
};

export default OtherLesions;
